import { createAsyncThunk } from '@reduxjs/toolkit';
import { PlaidApi, PlaidRequestParams } from 'api/PlaidApi';

export const createSetBankAccountsThunk = (api: PlaidApi) =>
  createAsyncThunk('plaid/setBankAccounts', async (payload: PlaidRequestParams) => {
    await api.setBankAccounts(payload.applicationId!, payload);
  });

export default createSetBankAccountsThunk;
